exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-mask{position:absolute;display:table;transition:opacity .3s ease}.modal-background,.modal-mask{z-index:9998;top:0;left:0;width:100%;height:100%}.modal-background{position:fixed;background-color:rgba(0,0,0,.5)}.modal-wrapper{display:table-cell;vertical-align:middle}.modal-container{position:relative;z-index:9999;width:80%;max-height:100%;margin:0 auto;padding:20px 30px;background-color:#fff;border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,.33);transition:all .3s ease;font-family:Helvetica,Arial,sans-serif}.modal-header h3{margin-top:0;color:#42b983}.modal-body{margin:20px 0}.modal-default-button{float:right}.modal-enter,.modal-leave-active{opacity:0}.modal-enter .modal-container,.modal-leave-active .modal-container{-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-73a3c974!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/custom-modal-old.vue
// module id = 373
// module chunks = 0